let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fRxDU")).then(() => parcelRequire('1qbF0'));